import React from 'react';

import { useSettings } from '@wix/tpa-settings/react';
import { Video } from '../../../../../../../components-shared/Video';
import challengeSettings from '../../../../../settingsParams';
import {
  FCWithChildren,
  IImageData,
  imageDataToMediaUrl,
} from '@wix/challenges-web-library';

import { classes, st } from './VisitorPageMedia.st.css';
import { useCSSPBStyle } from '../../../../../../../hooks/useCSSPBStyle';
import { getProgramAltImageText } from '../../../../../../../selectors/getProgramImageAltText';
import { useChallengeData } from '../../../../../../../contexts/storage-contexts/Challenge';
import { visitorPageMediaDataHooks } from './VisitorPageMediaDataHooks';
import { ImageResizeOptions, WowImage } from 'wix-ui-tpa/cssVars';
import { CropSelection } from '../../../../../../ChallengesList/Settings/challengeSettings/challengeSettings.types';

interface IVisitorPageMediaProps {
  className?: string;
  isInline: boolean;
}

function cropSelectionToFocalPoint(cropSelection: CropSelection) {
  switch (cropSelection) {
    case CropSelection.Bottom:
      return { x: 50, y: 100 };
    case CropSelection.top:
      return { x: 50, y: 0 };
    case CropSelection.Left:
      return { x: 0, y: 50 };
    case CropSelection.Right:
      return { x: 100, y: 50 };
    case CropSelection.TopLeft:
      return { x: 0, y: 0 };
    case CropSelection.TopRight:
      return { x: 100, y: 0 };
    case CropSelection.BottomLeft:
      return { x: 0, y: 100 };
    case CropSelection.BottomRight:
      return { x: 100, y: 100 };
    case CropSelection.Middle:
    default:
      return { x: 50, y: 50 };
  }
}
export const VisitorPageMedia: FCWithChildren<IVisitorPageMediaProps> = ({
  isInline,
  className,
}) => {
  const settings = useSettings();
  const {
    challengeData: { challenge },
  } = useChallengeData();
  const challengeDescriptionMedia = challenge?.settings?.description?.media;
  const isMockImage = !challengeDescriptionMedia && isInline;
  const getStyle = useCSSPBStyle();
  const cssPBStyle = getStyle({ displayVar: '--opgDisplayHeaderImage' });
  const displayHeader = cssPBStyle
    ? true
    : settings.get(challengeSettings.displayHeaderImage);
  const isShouldBeRendered =
    displayHeader && (challengeDescriptionMedia || isMockImage);

  const isVideo = challengeDescriptionMedia?.video;

  const image = challengeDescriptionMedia?.image as IImageData;
  return isShouldBeRendered ? (
    <figure
      className={`${st(classes.root, {
        inline: isInline,
      })} ${className}`}
      data-hook={visitorPageMediaDataHooks.desktopMedia()}
      style={cssPBStyle}
    >
      <div className={classes.imageRatioBox}>
        <div className={classes.imageRatioBoxInner}>
          {/* eslint-disable-next-line no-nested-ternary */}
          {isVideo ? (
            <Video
              altText={getProgramAltImageText(challenge)}
              className={classes.mediaItem}
              thumbnail={challengeDescriptionMedia?.video?.thumbnail}
              video={challengeDescriptionMedia?.video}
            />
          ) : isMockImage ? (
            <div className={classes.mediaMockImage} />
          ) : (
            <WowImage
              alt={getProgramAltImageText(challenge)}
              className={classes.mediaItem}
              src={imageDataToMediaUrl(image, {
                type: 'fill',
                maxHeight: image.height,
                maxWidth: image.width,
              })}
              sourceHeight={image.height}
              sourceWidth={image.width}
              data-hook="visitorPageMediaDataHooks-image"
              resize={ImageResizeOptions.cover}
              focalPoint={cropSelectionToFocalPoint(
                settings.get(challengeSettings.cropSelection),
              )}
            />
          )}
        </div>
      </div>
    </figure>
  ) : null;
};
